__turbopack_context__.v({
  "accordion-header": "AccordionHeading-module-scss-module__jC6lnG__accordion-header",
  "accordion-header-button": "AccordionHeading-module-scss-module__jC6lnG__accordion-header-button",
  "accordion-header-button-container": "AccordionHeading-module-scss-module__jC6lnG__accordion-header-button-container",
  "accordion-icon-container": "AccordionHeading-module-scss-module__jC6lnG__accordion-icon-container",
});
